module.exports = __webpack_public_path__ + "fonts/MyriadPro-Light.cacdec2.woff";